module.exports = __webpack_public_path__ + "static/media/crane.7596b2c8.svg";